module.exports = __webpack_public_path__ + "static/media/shopify9.6ac59fe1.png";